import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";

export const Route = createFileRoute("/_default/money-back-policy")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LegalPage
      titleKey="legal_money_back_title"
      bodyKey="legal_money_back_body"
    />
  );
}
